import React from "react";

export default function ServiceTab({ formData, onChange, disabled }) {
  return (
    <div className="role-tab">
      {/* Enable Service Management */}
      <div className="role-tab__header">
        <h3 className="role-tab__title">Service Management Configuration</h3>
        <label className="role-form__checkbox-label role-form__checkbox-label--large">
          <input
            type="checkbox"
            checked={formData.enableServiceManagement}
            onChange={(e) =>
              onChange("enableServiceManagement", e.target.checked)
            }
            disabled={disabled}
          />
          <span>Enable Service Management</span>
        </label>
      </div>
    </div>
  );
}
